// @flow

import { POSTHOG_EVENTS, posthogCapture } from '../posthog'
import {
  CHATBOT_EVENTS,
  type StartedEventPayload,
  type RestartedEventPayload,
  type RecommendedProductClickedEventPayload,
  type AddedToCartEventPayload,
  type RoutineAddedToCartEventPayload,
  type AttributeMatchingListExpandedEventPayload,
  type RecommendedProductInfoClickedEventPayload,
  type MoreProductsLoadedEventPayload
} from '../types'

function posthogCaptureStartedEvent (eventPayload: StartedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.STARTED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    trigger: eventPayload.trigger,
    eventDescription: 'conversation was started',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureRestartedEvent (eventPayload: RestartedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.STARTED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    trigger: 'restart',
    eventDescription: 'conversation was started',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureRecommendedProductClickedEvent (eventPayload: RecommendedProductClickedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.RECOMMENDED_PRODUCT_CLICKED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productId: eventPayload.productId,
    eventDescription: 'recommended product clicked',
    $current_url: eventPayload.parentUrl,
    utility: eventPayload.utility
  })
}

function posthogCaptureAddedToCartEvent (eventPayload: AddedToCartEventPayload) {
  posthogCapture(POSTHOG_EVENTS.ATC_CLICKED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productId: eventPayload.productId,
    eventDescription: 'add to cart button clicked',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureRoutineAddedToCartEvent (eventPayload: RoutineAddedToCartEventPayload) {
  posthogCapture(POSTHOG_EVENTS.ATC_ROUTINE_BUTTON_CLICKED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productIds: eventPayload.productIds,
    eventDescription: 'add to cart routine button clicked',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureAttributeMatchingListExpandedEvent (eventPayload: AttributeMatchingListExpandedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.MATCHING_PANEL_EXPANDED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productId: eventPayload.productId,
    eventDescription: 'recommended product attribute matching list expanded',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureRecommendedProductInfoClickedEvent (eventPayload: RecommendedProductInfoClickedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.PRODUCT_INFO_BUTTON_CLICKED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productId: eventPayload.productId,
    eventDescription: 'recommended product info button clicked',
    $current_url: eventPayload.parentUrl
  })
}

function posthogCaptureMoreProductsLoadedEvent (eventPayload: MoreProductsLoadedEventPayload) {
  posthogCapture(POSTHOG_EVENTS.MORE_PRODUCTS_LOADED, {
    interface: 'chatbot',
    subscriberId: eventPayload.subscriberId,
    chatbotId: eventPayload.chatbotId,
    productIds: eventPayload.productIds,
    eventDescription: 'clicked the button to load more products',
    $current_url: eventPayload.parentUrl
  })
}

export function registerPosthogListeners (): void {
  window.addEventListener(CHATBOT_EVENTS.Started, ({ detail }) => posthogCaptureStartedEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.Restarted, ({ detail }) => posthogCaptureRestartedEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.RecommendedProductClicked, ({ detail }) => posthogCaptureRecommendedProductClickedEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.AddedToCart, ({ detail }) => posthogCaptureAddedToCartEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.RoutineAddedToCart, ({ detail }) => posthogCaptureRoutineAddedToCartEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.AttributeMatchingListExpanded, ({ detail }) => posthogCaptureAttributeMatchingListExpandedEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.RecommendedProductInfoClicked, ({ detail }) => posthogCaptureRecommendedProductInfoClickedEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.MoreProductsLoaded, ({ detail }) => posthogCaptureMoreProductsLoadedEvent(detail))
}
